import { createStore } from 'vuex'
import {FuneralPlanTab} from "@/shared/domain/enum/funeral-plan-tab.model";
import {ICity} from "@/shared/domain/city.model";
import { toRaw } from 'vue';
import {IStateProvince} from "@/shared/domain/state-province.model";
import {IFuneralPlanSupplier} from "@/shared/domain/funeral-plan-supplier.model";
import {ICompanyXFuneralPlanSupplier} from "@/shared/domain/company-x-funeral-plan-supplier.model";
import {PaymentMethodEnum} from "@/shared/domain/enum/payment-method.enum";
import {IContract} from "@/shared/domain/contract.model";
import {IFuneralPlanBeneficiary} from "@/shared/domain/funeral-plan-beneficiary.model";
import {IUser} from "@/shared/domain/user.model";
import {InsuranceContract} from "@/views/dashboard/ContractDashboardPage.vue";
import {DeceasedTransportCoverType} from "@/shared/domain/enum/deceased-transport-cover-type.enum";
import {IContractPayment} from "@/shared/domain/contract-payment.model";
import {IFuneralPlanFilterOption} from "@/shared/domain/funeral-plan-filter-option.model";

export class LegacyVueStore {
  public funeralPlanTab?: FuneralPlanTab;
  public selectedFuneralPlanGroup?: unknown;
  public funeralPlanFilterOptions?: IFuneralPlanFilterOption[] | null;
  public city?: ICity | null;
  public stateProvince?: IStateProvince | null;
  public deathCity?: ICity | null;
  public deathStateProvince?: IStateProvince | null;
  public funeralPlanSupplier?: IFuneralPlanSupplier | null;
  public companyXFuneralPlanSupplier?: ICompanyXFuneralPlanSupplier | null;
  public paymentMethod?: PaymentMethodEnum | null;
  public contract?: IContract | null;
  public funeralPlanBeneficiary?: IFuneralPlanBeneficiary | null;
  public funeralPlanHolder?: IFuneralPlanBeneficiary | null;
  public isPetSupportAdded?: boolean | null;
  public user?: IUser | null;
  public beneficiaryDeath?: IFuneralPlanBeneficiary | null;
  public insuranceContract?: InsuranceContract | null;
  public deceasedTransportCoverType?: DeceasedTransportCoverType | null;
  public firstLoad?: boolean;
  public contractPayments?: IContractPayment[];
  public forceToFilterByLegacySupplierCompaniesId?: number | null;
  public repayToken?: string;
  public funeralSupplierIdFilter?: number | null;
  public legacySupplierCompaniesIdFilter?: number | null;
  public styleMode?: 'legacy' | 'primaveras' | 'mag-seguros';
  public showFullLoad: boolean;
  public initPurchaseUrl: string | null;
  public isMagSeguros?: boolean;
  public authenticationToken: string | null;
  /**
   * This code is used to configure the commissions of the Contract
   */
  public commissionCode?: string;

  constructor() {
    this.funeralPlanTab = FuneralPlanTab.LOST_SOMEONE;
    this.selectedFuneralPlanGroup = null;
    this.funeralPlanFilterOptions = [];
    this.city = null;
    this.stateProvince = null;
    this.deathCity = null;
    this.deathStateProvince = null;
    this.funeralPlanSupplier = null;
    this.companyXFuneralPlanSupplier = null;
    this.paymentMethod = null;
    this.contract = null;
    this.funeralPlanBeneficiary = null;
    this.funeralPlanHolder = null;
    this.isPetSupportAdded = null;
    this.user = null;
    this.beneficiaryDeath = null;
    this.insuranceContract = null;
    this.deceasedTransportCoverType = null;
    this.firstLoad = true;
    this.contractPayments = [];
    this.forceToFilterByLegacySupplierCompaniesId = null;
    this.repayToken = '';
    this.commissionCode = '';
    this.funeralSupplierIdFilter = null;
    this.legacySupplierCompaniesIdFilter = null;
    this.styleMode = 'legacy';
    this.showFullLoad = true;
    this.initPurchaseUrl = null;
    this.isMagSeguros = false;
    this.authenticationToken = null;
  }
}

export default createStore({
  state: new LegacyVueStore(),
  mutations: {
    changeStyleMode: (state, styleMode: 'legacy' | 'primaveras' | 'mag-seguros') => {
      state.styleMode = styleMode;
    },
    changeShowFullLoad: (state, show: boolean) => {
      state.showFullLoad = show;
    },
    changeFuneralPlanTab: (state, tab) => {
      state.funeralPlanTab = tab;
    },
    changeSelectedFuneralPlanGroup: (state, funeralPlanGroupId) => {
      state.selectedFuneralPlanGroup = funeralPlanGroupId;
    },
    changeFuneralPlanFilterOptions: (state, funeralPlanFilterOptions) => {
      state.funeralPlanFilterOptions = funeralPlanFilterOptions;
    },
    changeCity: (state, city) => {
      state.city = city;
    },
    changeDeathStateProvince: (state, stateProvince) => {
      state.deathStateProvince = stateProvince;
    },
    changeDeathCity: (state, city) => {
      state.deathCity = city;
    },
    changeStateProvince: (state, stateProvince) => {
      state.stateProvince = stateProvince;
    },
    changeFuneralPlanSupplier: (state, funeralPlanSupplier) => {
      state.funeralPlanSupplier = funeralPlanSupplier;
    },
    changeCompanyXFuneralPlanSupplier: (state, companyXFuneralPlanSupplier) => {
      state.companyXFuneralPlanSupplier = companyXFuneralPlanSupplier;
    },
    changeContract: (state, contract) => {
      state.contract = contract;

      state.funeralPlanBeneficiary = contract.funeralPlanBeneficiary;
      state.funeralPlanHolder = contract.funeralPlanHolder;
      state.contractPayments = contract.contractPayments;

    },
    resetContract: (state) => {
      state.contract = null;
    },
    changeFuneralPlanBeneficiary: (state, funeralPlanBeneficiary) => {
      state.funeralPlanBeneficiary = funeralPlanBeneficiary;
    },
    changeFuneralPlanHolder: (state, funeralPlanHolder) => {
      state.funeralPlanHolder = funeralPlanHolder;
    },
    changePetSupportAdded: (state, isPetSupportAdded) => {
      state.isPetSupportAdded = isPetSupportAdded;
    },
    changeUser: (state, user) => {
      state.user = user;
    },
    changeBeneficiaryDeath: (state, funeralPlanBeneficiary)  => {
      state.beneficiaryDeath = funeralPlanBeneficiary;
    },
    changeInsuranceContract: (state, insuranceContract)  => {
      state.insuranceContract = insuranceContract;
    },
    changeDeceasedTransportCoverType: (state, type) => {
      state.deceasedTransportCoverType = type;
    },
    changeContractPayment: (state, contractPayment) => {
      if (state.contractPayments && state.contractPayments.length > 1){
        const index = state.contractPayments.findIndex((contractPayment_: any) => contractPayment.index == contractPayment_.index);
        console.log("Change contract payment INDEX:" +index);
        if(index >= 0) {
          Object.assign(state.contractPayments[index], toRaw(contractPayment));
        }
      }
    },
    changeForceToFilterByLegacySupplierCompaniesId: (state, id) => {
      state.forceToFilterByLegacySupplierCompaniesId = id;
    },
    changeContractPayments: (state, contractPayments) => {
      state.contractPayments = contractPayments;
    },
    resetContractPayments: (state) => {
      state.contractPayments = [];
    },
    pushContractPayment: (state, contractPayment) => {
      if (state.contractPayments === undefined){
        state.contractPayments = [];
      }
      const clone = {};
      Object.assign(clone, toRaw(contractPayment));
      state.contractPayments.push(clone);
    },
    spliceContractPayments: (state, spliceArgs) => {
      if (state.contractPayments) {
        state.contractPayments.splice(spliceArgs.start, spliceArgs.deleteCount);
      }
    },
    changingRepayToken: (state, repayToken: string) => {
      state.repayToken = repayToken;
    },
    changeCommissionCode: (state, commissionCode: string) => {
      state.commissionCode = commissionCode;
    },
    changeFuneralSupplierIdFilter: (state, funeralSupplierIdFilter: number) => {
      state.funeralSupplierIdFilter = funeralSupplierIdFilter;
    },
    changeLegacySupplierCompaniesIdFilter: (state, legacySupplierCompaniesIdFilter: number) => {
      state.legacySupplierCompaniesIdFilter = legacySupplierCompaniesIdFilter;
    },
    changeInitPurchaseUrl: (state, url: string) => {
      state.initPurchaseUrl = url;
    },
    resetValues: (state) => {
      state.selectedFuneralPlanGroup = null;
      state.funeralPlanFilterOptions = [];
      state.city = null;
      state.stateProvince = null;
      state.deathCity = null;
      state.deathStateProvince = null;
      state.funeralPlanSupplier = null;
      state.contract = null;
      state.funeralPlanBeneficiary = null;
      state.funeralPlanHolder = null;
      state.isPetSupportAdded = false;
      state.beneficiaryDeath = null;
      state.insuranceContract = null;
      state.deceasedTransportCoverType = null;
      state.contractPayments = [];
      state.companyXFuneralPlanSupplier = null;
      state.isMagSeguros = false;
      state.authenticationToken = null;
      localStorage.removeItem("state");
    },
    updateFirstLoad: (state) => {
      state.firstLoad = false;
    },
    saveStateToCache: (state) => {
      let contract;
      if(state.contract) {
        contract = {} as any;
        Object.assign(contract, state.contract);
        contract.cardInfo = null;
       /* if(contract.payerData) {
          const payerData = {} as any;
          Object.assign(payerData, contract.payerData);
          payerData.idPhotoFile = null;
          payerData.idPhotoBlob = null;
          contract.payerData = payerData;
        }
        if(contract.addressData) {
          const addressData = {} as any;
          Object.assign(addressData, contract.addressData);
          addressData.addressProofPhotoFile = null;
          addressData.addressProofPhotoBlob = null;
          contract.addressData = addressData;
        }*/
        if(contract.contractDeceased) {
          const contractDeceased = {} as any;
          Object.assign(contractDeceased, contract.contractDeceased);
          contractDeceased.idPhotoFile = null;
          contractDeceased.photo1File = null;
          contractDeceased.idPhotoBlob = null;
          contractDeceased.photo1Blob = null;
          contract.contractDeceased = contractDeceased;
        }
      }
      const contractPayments = [];
      if(state.contractPayments && state.contractPayments.length > 0) {
        for(let i = 0; i < state.contractPayments.length; i++) {
          const contractPayment = {} as any;
          Object.assign(contractPayment, toRaw(state.contractPayments[i]));
          contractPayment.payerData.idPhotoBlob = null;
          contractPayment.payerData.idPhotoFile = null;
          contractPayment.idPhotoBlob = null;
          contractPayment.customerInvoiceFile = null;
          contractPayment.addressData.addressProofPhotoFile = null;
          contractPayment.addressData.addressProofPhotoBlob = null;
          contractPayment.cardInfo = null;
          contractPayments.push(contractPayment);
        }
      }

      let obj = {
        "funeralPlanTab": state.funeralPlanTab,
        "selectedFuneralPlanGroup": state.selectedFuneralPlanGroup,
        "funeralPlanFilterOptions": state.funeralPlanFilterOptions,
        "city": state.city,
        "stateProvince": state.stateProvince,
        "deathCity": state.deathCity,
        "deathStateProvince": state.deathStateProvince,
        "funeralPlanSupplier": state.funeralPlanSupplier,
        "contract": contract,
        "funeralPlanBeneficiary": state.funeralPlanBeneficiary,
        "funeralPlanHolder": state.funeralPlanHolder,
        "isPetSupportAdded": state.isPetSupportAdded,
        "beneficiaryDeath": state.beneficiaryDeath,
        "insuranceContract": state.insuranceContract,
        "deceasedTransportCoverType": state.deceasedTransportCoverType,
        "contractPayments": contractPayments,
        "companyXFuneralPlanSupplier": state.companyXFuneralPlanSupplier,
        "forceToFilterByLegacySupplierCompaniesId": state.forceToFilterByLegacySupplierCompaniesId,
        "styleMode": state.styleMode,
        "showFullLoad": state.showFullLoad,
        "initPurchaseUrl": state.initPurchaseUrl,
      };

      obj = Object.fromEntries(Object.entries(obj).filter((v: any) => v != null)) as any;
      if(obj) {
        localStorage.setItem("state", JSON.stringify(obj));
      }
    },
    updateState: (state, stateData) => {
      if(stateData) {
        Object.assign(state, stateData);
      }
    },
    setMagSeguros: (state, isMagSeguros) => {
      state.isMagSeguros = isMagSeguros;
    },
    changeAuthenticationToken: (state, authenticationToken) => {
      state.authenticationToken = authenticationToken;
    }
  },
  modules: {
  },
  getters: {
    isMagSeguros: state => {
      return state.isMagSeguros
    },
    getStyleMode: (state) => {
      return state.styleMode;
    },
    getFuneralPlanTab: (state) => {
        return state.funeralPlanTab;
    },
    getSelectedFuneralPlanGroup: (state) => {
      return state.selectedFuneralPlanGroup;
    },
    getFuneralPlanFilterOptions: (state) => {
      return state.funeralPlanFilterOptions;
    },
    getCity: (state) => {
      return state.city;
    },
    getStateProvince: (state) => {
      return state.stateProvince;
    },
    getDeathCity: (state) => {
      return state.deathCity;
    },
    getDeathStateProvince: (state) => {
      return state.deathStateProvince;
    },
    getFuneralPlanSupplier: (state) => {
      return state.funeralPlanSupplier;
    },
    getCompanyXFuneralPlanSupplier: (state) => {
      return state.companyXFuneralPlanSupplier;
    },
    getContract: (state) => {
      return state.contract;
    },
    getFuneralPlanBeneficiary: (state) => {
      return {...state.funeralPlanBeneficiary};
    },
    getFuneralPlanHolder: (state) => {
      return state.funeralPlanHolder;
    },
    getPetSupportAdded: (state) => {
      return state.isPetSupportAdded;
    },
    getUser: (state) => {
      return state.user;
    },
    getBeneficiaryDeath: (state) => {
      return state.beneficiaryDeath;
    },
    getInsuranceContract: (state) => {
      return state.insuranceContract;
    },
    getDeceasedTransportCoverType: (state) => {
      return state.deceasedTransportCoverType;
    },
    firstLoad: (state) => {
      return state.firstLoad;
    },
    getContractPayments: (state) => {
      return state.contractPayments;
    },
    getForceToFilterByLegacySupplierCompaniesId: (state) => {
      return state.forceToFilterByLegacySupplierCompaniesId;
    },
    getRepayToken: (state) => {
      return state.repayToken;
    },
    getCommissionCode: (state) => {
      return state.commissionCode;
    },
    getFuneralSupplierIdFilter: (state) => {
      return state.funeralSupplierIdFilter;
    },
    getLegacySupplierCompaniesIdFilter: (state) => {
      return state.legacySupplierCompaniesIdFilter;
    },
    getShowFullLoad: (state) => {
      return state.showFullLoad;
    },
    getInitPurchaseUrl: (state) => {
      return state.initPurchaseUrl;
    },
    getAuthenticationToken: (state) => {
      return state.authenticationToken;
    }
  },
})
